import { CafCorpusAction, CafCorpusEntry, CafExtractionSchema, CafFinalResponseStance } from '../../../api/cafCorpus';

/** The POST label/from-task routes build replacement guidance; omitted values clear. */
export interface ReplacementGuidance {
  action: CafCorpusAction;
  note: string;
  reason: string;
  extraction_schema?: CafExtractionSchema | null;
  categoryOverride?: CafCorpusEntry['category_override'];
  archive_override_refs?: boolean;
  final_response_stance?: CafFinalResponseStance;
}

/** Mirror the backend schema validator's stored shape, including field order. */
export const schemaForComparison = (schema: CafExtractionSchema | null | undefined) => {
  if (!schema?.fields.length) return null;
  return {
    enabled: Boolean(schema.enabled),
    fields: schema.fields.map((field) => ({
      id: field.id.trim(),
      label: field.label.trim(),
      description: (field.description ?? '').trim(),
      dataType: field.dataType,
      targetClaimField: field.targetClaimField.trim(),
      required: Boolean(field.required),
      ...(field.dataType === 'enum' ? { options: (field.options ?? []).map((option) => option.trim()) } : {}),
    })),
  };
};

export const matchesReplacementGuidance = (fresh: CafCorpusEntry, intended: ReplacementGuidance): boolean =>
  fresh.active === true
  && fresh.correct_action === intended.action
  && fresh.note === intended.note.trim()
  && fresh.reason === intended.reason.trim()
  && JSON.stringify(schemaForComparison(fresh.extraction_schema))
    === JSON.stringify(schemaForComparison(intended.extraction_schema))
  && (fresh.category_override ?? null) === (intended.categoryOverride ?? null)
  && Boolean(fresh.archive_override_refs) === Boolean(intended.archive_override_refs)
  && (intended.final_response_stance === undefined || fresh.final_response_stance === intended.final_response_stance);
